import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { CheckoutFormComponent } from '../../checkout/checkout-form.component';
import { CheckoutStepComponent } from '../../checkout/checkout-step.component';
import { ResultComponent } from '../../ui/api/result.component';
import { KlarnaPaymentComponentDef } from './klarna-payment.component.def';

@Component({
    selector: 'klarna-payment',
    templateUrl: './klarna-payment.html',
    standalone: true,
    imports: [CommonModule, ResultComponent]
})
export class KlarnaPaymentComponent extends KlarnaPaymentComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        changeDetectorRef: ChangeDetectorRef,
        scrollToService: ScrollToService,
        checkoutStepComponent: CheckoutStepComponent
    ) {
        super(checkoutFormComponent, changeDetectorRef, scrollToService, checkoutStepComponent);
    }
}
